import { executeRequest, JFSRequest } from '@jfs/network'
import { IS_ONLY_ONBOARDING, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  let accessAconfig = data?.group?.accessConfig
  if (data?.group?.id === 61) {
    accessAconfig = {
      aadhar_redaction: { isAccessible: true, search: { isAccessible: true }, checker: { isAccessible: true } },
    }
  } else if (data?.group?.id === 62) {
    accessAconfig = {
      aadhar_redaction: { maker: { isAccessible: true }, isAccessible: true, search: { isAccessible: true } },
    }
  }
  return {
    id: data?.id,
    name: data?.username,
    group: data?.group?.type,
    accessConfig: accessAconfig,
  }
}

const menuInfo = (name: string, tokens: string) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getMenuInfo),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
  }
  if (IS_ONLY_ONBOARDING) {
    return Promise.resolve(
      responseParser({
        data: {
          id: 161,
          username: name.split('@')[0],
          type: 'DEV',
          lastUsed: 1682528904091,
          createdDate: 1658895359934,
          createdBy: 'NA',
          isActive: true,
          group: {
            id: 1,
            type: 'GROUP',
            name: 'adminn',
            accessConfig: {
              merchant_config: {
                isAccessible: true,
                merchant_mapping: {
                  isAccessible: true,
                  add: { isAccessible: true },
                  update: { isAccessible: true },
                  approve: { isAccessible: true },
                  fetch: { isAccessible: true },
                  delete: { isAccessible: true },
                },
                device_mapping: {
                  isAccessible: true,
                  fetch: { isAccessible: true },
                  unlink: { isAccessible: true },
                  create: { isAccessible: true },
                },
                sap_onboarding: { isAccessible: true, create: { isAccessible: true } },
                bulk_merchant_onboarding: { isAccessible: true, create: { isAccessible: true } },
                merchant_onboarding: { isAccessible: true, create: { isAccessible: true } },
                createChannel: { isAccessible: true, create: { isAccessible: true } },
                apiConfiguration: { isAccessible: true, create: { isAccessible: true } },
              },
            },
          },
        },
      }),
    )
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { menuInfo }
